module.exports = __webpack_public_path__ + "static/media/add.5784ae81.png";